"use client";
import { jsx } from "react/jsx-runtime";
import { useQueryParams } from "../../../../utils/QueryParamsProvider/QueryParamsProvider.js";
import { useState, useMemo, useEffect } from "react";
import { Analytics } from "../../../Analytics/index.js";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { PRODUCT_ITEM_TYPE } from "../constants.js";
import { isAdobeScriptReady } from "../../../../hooks/useAdobe/index.js";
import { CategoryAdSet } from "./CategoryAdSet.js";
import { ProductAdSet } from "./ProductAdSet.js";
const AdobeAdSet = ({
  entry,
  locale,
  titleProps,
  maxSlides,
  maxSlidesBySize,
  productTileSx,
  carouselContainerSx,
  sx,
  contextData,
  isProductDetailsPage
}) => {
  var _a;
  const { thirdPartyInfo } = useBrowseContext();
  const { consentManagement } = thirdPartyInfo;
  const { isTargetingEnabled } = consentManagement || {};
  const { queryParams: searchParams } = useQueryParams();
  const [isScriptLoaded, setIsScriptLoaded] = useState(isAdobeScriptReady);
  const keyword = useMemo(() => {
    return (searchParams == null ? void 0 : searchParams.get("keyword")) || "";
  }, [searchParams]);
  const { item_type, title, uid } = entry;
  useEffect(() => {
    const handler = () => {
      !isScriptLoaded && setIsScriptLoaded(true);
    };
    document.addEventListener("at-library-loaded", handler);
    return () => {
      document.removeEventListener("at-library-loaded", handler);
    };
  }, [isScriptLoaded]);
  if (!isTargetingEnabled) {
    return null;
  }
  return item_type === PRODUCT_ITEM_TYPE ? isScriptLoaded && /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: {
          style: "carousel",
          title: (_a = entry == null ? void 0 : entry.ad_set_heading_and_costco_url) == null ? void 0 : _a.title,
          type: "product"
        },
        title
      },
      children: /* @__PURE__ */ jsx(
        ProductAdSet,
        {
          carouselContainerSx,
          contextData,
          entry,
          isProductDetailsPage,
          keyword,
          locale,
          maxSlides,
          maxSlidesBySize,
          productTileSx,
          sx,
          titleProps
        }
      )
    }
  ) : isScriptLoaded && /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: { style: "banner", type: "category" },
        title: entry.title
      },
      children: /* @__PURE__ */ jsx(
        CategoryAdSet,
        {
          entry,
          entryId: uid,
          keyword: (searchParams == null ? void 0 : searchParams.get("keyword")) || "",
          sx,
          titleProps
        }
      )
    }
  );
};
export {
  AdobeAdSet
};
